let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j3w3L")).then(() => parcelRequire('1G3L8'));